import _ from 'lodash';
import notification from 'app/config/notification';
import { SERVICES_CODES, SERVICES_PROPERTIES } from 'app/config/services';

import { registrationPayload, registrationPersonPayload } from '../payloadsStruture';

export const setupCompanyPayload = ({ values, intl, cdServico, cdSolicitacao }) => {
  const valuesCopy = { ...values };

  if (valuesCopy.contatos) {
    let contacts = [];
    let onlyContacts = valuesCopy.contatos.filter(contact => {
      return (
        (contact.peParticipacaoSocietaria === null ||
          contact.peParticipacaoSocietaria === undefined) &&
        !contact.boExcluido
      );
    });

    let hasContactError = false;
    let hasPartnerError = false;

    if (!onlyContacts || onlyContacts.length === 0) hasContactError = true;
    else {
      onlyContacts.forEach(contact => {
        //CONTACT VALIDATION
        const keys = Object.keys(contact);

        if (
          !keys.includes('nmPessoa') ||
          contact.nmPessoa === '' ||
          !keys.includes('deFuncao') ||
          contact.deFuncao === '' ||
          !keys.includes('deTelefoneMovel') ||
          contact.deTelefoneMovel === '' ||
          !keys.includes('deEmail') ||
          contact.deEmail === ''
        ) {
          hasContactError = true;
        }
      });
      contacts = onlyContacts;
    }

    if (!valuesCopy.cdTipoPessoaFisica) {
      if (!valuesCopy.socios || valuesCopy.socios.length === 0) {
        if (valuesCopy.contatos) {
          const partners = values.contatos.filter(
            contact => !!contact.peParticipacaoSocietaria && !contact.boExcluido
          );
          if (partners.length > 0) {
            valuesCopy.socios = partners;
          }
        }
      }

      if (!valuesCopy.socios || valuesCopy.socios.length === 0) hasPartnerError = true;
      else {
        valuesCopy.socios.forEach(contact => {
          //PARTNERS VALIDATION
          const keys = Object.keys(contact);
          if (
            !keys.includes('nmPessoa') ||
            contact.nmPessoa === '' ||
            !keys.includes('deFuncao') ||
            contact.deFuncao === '' ||
            !keys.includes('peParticipacaoSocietaria') ||
            contact.peParticipacaoSocietaria === ''
          ) {
            hasPartnerError = true;
          }
        });
        contacts = [].concat(onlyContacts, valuesCopy.socios);
      }

      if (valuesCopy.contatosExcluidos && valuesCopy.contatosExcluidos?.length > 0) {
        contacts = [].concat(onlyContacts, valuesCopy.socios, valuesCopy.contatosExcluidos);
      }
    } else {
      if (valuesCopy.contatosExcluidos && valuesCopy.contatosExcluidos?.length > 0) {
        contacts = [].concat(onlyContacts, valuesCopy.contatosExcluidos);
      }
    }

    if (hasContactError) {
      notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.CONTACT_INFO_MISSING' }), {
        toastId: 'CONTACT_INFO_MISSING',
        type: 'error',
      });
      return;
    }

    if (hasPartnerError) {
      notification(intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.PARTNER_INFO_MISSING' }), {
        toastId: 'CONTACT_INFO_MISSING',
        type: 'error',
      });
      return;
    }

    valuesCopy.contatos = contacts;

    if (valuesCopy.contatos.length > 0) {
      let hasPrincipalContact = false;
      valuesCopy.contatos.forEach(contact => {
        if (contact.boPrincipalContato) hasPrincipalContact = true;
      });

      if (!hasPrincipalContact) {
        notification(
          intl.formatMessage({ id: 'MESSAGES.SERVICE.FORMS.PRINCIPAL_CONTACT_MISSING' }),
          {
            toastId: 'PRINCIPAL_CONTACT_MISSING',
            type: 'error',
          }
        );
        return false;
      }
    }
  }

  if (valuesCopy.cdEmpresa) {
    if (valuesCopy.certificado) delete valuesCopy.certificado;
    if (valuesCopy.boSituacaoOrgao != null) delete valuesCopy.boSituacaoOrgao;
  }

  if (
    (!cdSolicitacao || cdSolicitacao === '') &&
    cdServico &&
    cdServico === SERVICES_CODES.INSCRICAO_CADASTRAL &&
    valuesCopy.cdEmpresa
  ) {
    delete valuesCopy.cdEmpresa;
  }

  return valuesCopy;
};

export const setupCompanyInitialValues = internalNewRequest => {
  let user = _.cloneDeep(internalNewRequest?.user);
  const isPerson = user.deCpfCnpj.length <= 11;

  if (internalNewRequest?.company) {
    const tempValues = _.cloneDeep(internalNewRequest.company);

    if (tempValues.cdUltimaSolicitacao != null) delete tempValues.cdUltimaSolicitacao;
    if (tempValues.cdCertificado != null) delete tempValues.cdCertificado;
    if (tempValues.tipoEmpresa != null) delete tempValues.tipoEmpresa;
    if (tempValues.ramoAtividade != null) delete tempValues.ramoAtividade;
    if (isPerson) {
      Object.keys(registrationPayload).forEach(k => {
        if (tempValues[k] != null && !Object.keys(registrationPersonPayload).includes(k)) {
          delete tempValues[k];
        }
      });
    } else {
      Object.keys(registrationPersonPayload).forEach(k => {
        if (tempValues[k] != null && !Object.keys(registrationPayload).includes(k)) {
          delete tempValues[k];
        }
      });
    }

    if (tempValues.documentos) delete tempValues.documentos;
    if (tempValues.ultimaSolicitacao) delete tempValues.ultimaSolicitacao;

    if (tempValues.enderecoMatriz && tempValues.enderecoMatriz.municipio) {
      tempValues.enderecoMatriz.uf = tempValues.enderecoMatriz.municipio.uf?.sgUf;
    }
    if (tempValues.enderecoFilial?.municipio?.uf) {
      tempValues.enderecoFilial.uf = tempValues.enderecoFilial.municipio.uf?.sgUf;
    }
    if (tempValues.enderecoPessoa && tempValues.enderecoPessoa.municipio) {
      tempValues.enderecoPessoa.uf = tempValues.enderecoPessoa.municipio.uf?.sgUf;
    }
    return tempValues;
  }

  let initValue = SERVICES_PROPERTIES[internalNewRequest.cdServico].formInitialValues;
  if (isPerson) {
    initValue = registrationPersonPayload;
    initValue.deCpf = user.deCpfCnpj || '';
    initValue.nmCompleto = user.nmUsuario || '';
  }

  const initialAddress = {};

  if (user && Object.keys(user).length > 0) {
    if (user.municipio) {
      initialAddress.municipio = user.municipio;
      initialAddress.uf = user.municipio.uf?.sgUf;
      initialAddress.cdMunicipio = user.cdMunicipio ? user.cdMunicipio : '';
    }
    if (user.deBairro) initialAddress.deBairro = user.deBairro;
    if (user.deCep) initialAddress.deCep = user.deCep;
    if (user.deComplemento) initialAddress.deComplemento = user.deComplemento;
    if (user.deCpfCnpj && user.deCpfCnpj.length > 11) initValue.deCnpjMatriz = user.deCpfCnpj;
    if (user.deEmail) initValue.deEmail = user.deEmail;
    if (user.deEndereco) initialAddress.deEndereco = user.deEndereco;
    if (user.deNumeroEndereco) initialAddress.deNumeroEndereco = user.deNumeroEndereco;
    if (user.deTelefone) initValue.deTelefone = user.deTelefone;
    if (user.nmUsuario) initValue.deRazaoSocial = user.nmUsuario;
  }

  if (isPerson) {
    initValue.enderecoPessoa = initialAddress;
  } else {
    initValue.enderecoMatriz = initialAddress;
  }

  initValue.documentos = [];

  return initValue;
};

export const getCompanyDataToInitialValue = internalNewRequest => {
  const result = {};
  if (internalNewRequest) {
    let baseData = { ...internalNewRequest.user };
    if (internalNewRequest.company) {
      baseData = { ...internalNewRequest.company };
    }

    result.deCpfCnpj = baseData.deCpfCnpj ? baseData.deCpfCnpj : baseData.deCnpjMatriz;
    result.nmCompleto = baseData.nmCompleto ? baseData.nmCompleto : baseData.deRazaoSocial;
    if (baseData.cdTipoEmpresa) result.cdTipoEmpresa = baseData.cdTipoEmpresa;
    if (baseData.cdTipoPessoaFisica) result.cdTipoPessoaFisica = baseData.cdTipoPessoaFisica;
  }

  return result;
};
